import { DefaultService } from '@/services/DefaultService';

export default class LeadsService extends DefaultService {

	constructor(http, router, env) {
		super(http, router, env);
	}

    findAll(column, order, page, limit, situacao, params) {
		return this._http.get(encodeURI(`${this._env}/ven/cliente/leads.json?page=${page}&limit=${limit}&order=${order}&column=${column}&situacao=${situacao}&param=${params}`), this._headers).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw new Error('Problems while jobs are loading');
		});
	}
    
    find(id) {
        return this._http.get(`${this._env}/ven/cliente/leads/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    getVendedores(search){
        return this._http.get(`${this._env}/ven/cliente/leads/vendedores.json?search=${search}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    getVendedor(idCliente, search) {
        return this._http.get(`${this._env}/ven/cliente/leads/vendedor?id=${idCliente}&search=${search}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
    
	save(cliente) {
		return this._http.post(`${this._env}/ven/cliente/leads/new`, cliente, this._headers).then(res => {
			return res.body;
		}, err => {
            this.verifyError(err);
            throw err;
        });
    }

    checkCliente(cnpj){
        return this._http.get(`${this._env}/ven/cliente/leads/check?cnpj=${cnpj}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    vincular(infoCliente) {
        console.log(`cp`, infoCliente)
		return this._http.post(`${this._env}/ven/cliente/leads/vincular`, infoCliente, this._headers).then(res => {
			return res.body;
		}, err => {
            this.verifyError(err);
            throw err;
        });
    }

    reject(infoCliente){
        return this._http.post(`${this._env}/ven/cliente/leads/reject`, infoCliente, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
}